import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Progress } from "../components/ui/progress";
import { ChevronRight, AlertTriangle } from "lucide-react";

export default function DivisionsOverview() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/divisions/overview").then(({ data }) => setRows(data)); }, []);
  return (
    <div className="space-y-6" data-testid="divisions-overview">
      <div>
        <h1 className="font-display text-2xl font-bold">Ringkasan Semua Divisi</h1>
        <p className="text-sm text-[#5C6066] mt-1">Overview operasional 9 divisi Dessy Wedding Group.</p>
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
        {rows.map((r) => (
          <Card key={r.division.id} className="p-5 border border-[#E5E0D8] bg-white shadow-none" data-testid={`div-card-${r.division.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className={`inline-flex px-2 py-0.5 rounded text-[10px] font-semibold border ${r.division.color || "bg-zinc-100"}`}>{r.division.short}</div>
                <h3 className="font-display font-semibold text-base mt-2">{r.division.name}</h3>
              </div>
              {r.overdue_tasks > 0 && <AlertTriangle className="w-4 h-4 text-rose-500" />}
            </div>
            <div className="grid grid-cols-2 gap-3 mt-4 text-sm">
              <Mini label="Acara Aktif" value={r.upcoming_events} />
              <Mini label="Job Aktif" value={r.active_jobs} />
              <Mini label="Overdue" value={r.overdue_tasks} tone={r.overdue_tasks > 0 ? "danger" : ""} />
              <Mini label="Staf" value={r.staff_count} />
              <Mini label="Bukti" value={r.evidence_count} />
              <Mini label="Completion" value={`${r.completion_pct}%`} />
            </div>
            <div className="mt-3">
              <Progress value={r.completion_pct} className="h-1.5" />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
const Mini = ({ label, value, tone }) => (
  <div>
    <div className="text-[10px] uppercase text-[#8C9096]">{label}</div>
    <div className={`font-semibold ${tone === "danger" ? "text-rose-700" : ""}`}>{value}</div>
  </div>
);
